// RequireAuth.tsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';

const ACTIVE_SUBSCRIPTION_STATUSES = new Set(['active', 'trialing', 'studio_included']);
const BILLING_REQUIRED_STATUSES = new Set(['past_due', 'unpaid']);

export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, subscriptionStatus, loading, profileReady, userRole, studioId } = useAuth();
  const location = useLocation();

  if (loading || (user && !profileReady)) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!userRole) {
    return <LoadingSpinner />;
  }

  const isStudioIncludedArtist = userRole === 'artist' && Boolean(studioId);

  if (
    subscriptionStatus &&
    BILLING_REQUIRED_STATUSES.has(subscriptionStatus) &&
    !isStudioIncludedArtist
  ) {
    return <Navigate to="/billing-required" state={{ from: location }} replace />;
  }

  if (
    !isStudioIncludedArtist &&
    subscriptionStatus !== 'unknown' &&
    !ACTIVE_SUBSCRIPTION_STATUSES.has(subscriptionStatus ?? '')
  ) {
    return <Navigate to="/subscribe" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
